import moment from 'moment';
/* import { browserHistory } from 'react-router';
 */
export const selectIsLive = store => {
  if (store?.Player?.Content?.data === null) {
    return null;
  }
  return (
    store?.Player?.Content?.data?.group?.common?.extendedcommon?.media
      ?.islive ===
    '1' /*  && browserHistory.getCurrentLocation().query.endTime === undefined */
  );
};

export const selectIsSerie = store => {
  if (store?.Player?.Content?.data === null) {
    return null;
  }
  return store?.Player?.Content?.data?.group?.common?.extendedcommon?.media
    ?.serie;
};

export const selectLiveRef = store => {
  if (store?.Player?.Content?.data === null) {
    return null;
  }
  return store?.Player?.Content?.data?.group?.common?.extendedcommon?.media
    ?.liveref;
};

export const selectMediaCertificate = store =>
  store?.metadata?.media_certificate;

export const selectCurrentContent = (groupId, offset) => state => {
  const listOfChannels = state?.Player?.EpgChannels.data;
  const currentChannel = listOfChannels?.find(
    channel => channel?.group_id === groupId,
  );

  const event = currentChannel?.events?.find(ev =>
    moment().isBetween(ev.date_begin, ev.date_end),
  );
  return event;
};

export const selectCurrentContentLive = (groupId, isPlayingTS) => state => {
  const listOfChannels = state?.Player?.EpgChannels?.data;
  const unixBeginSaved = state?.Player?.UnixBegin.unixBegin;
  const currentChannel = listOfChannels?.find(
    channel => channel?.group_id === groupId,
  );
  const eventTs = currentChannel?.events?.find(
    e => e?.unix_begin === unixBeginSaved,
  );
  const eventLive = currentChannel?.events?.find(ev =>
    moment().isBetween(ev?.date_begin, ev?.date_end),
  );
  const event = isPlayingTS ? eventTs : eventLive;
  return event;
};

export const selectIsLiveChannel = groupId => state => {
  const epgLineUp = state?.EpgLineUp?.data;
  if (epgLineUp === null) return;
  const channelFromEpgchannel = epgLineUp?.find(
    channel => channel?.group_id === groupId,
  );
  return !!channelFromEpgchannel;
};
